import { useNavigate, useParams } from 'react-router-dom'

/**
 * Hook to navigate within the app while preserving the current locale
 * Always gets the current locale from the URL (useParams) at navigation time
 * Usage: const navigate = useAppNavigate()
 *        navigate('dashboard') // goes to /pt/dashboard (or whatever locale is in URL)
 */
export function useAppNavigate() {
  const navigate = useNavigate()
  const { locale } = useParams<{ locale: string }>()
  const currentLocale = locale || 'en'

  return (page: string) => {
    navigate(`/${currentLocale}/${page}`)
  }
}
